import React from 'react';
import { Modal, Space, Typography, Select, DatePicker } from 'antd';

const { Text } = Typography;
const { RangePicker } = DatePicker;

const FilterModal = ({
  isVisible,
  onClose,
  onApply,
  statusFilter,
  setStatusFilter,
  clientFilter,
  setClientFilter,
  dateRange,
  setDateRange,
  products
}) => {
  return (
    <Modal
      title="Filtre Avansate"
      open={isVisible}
      onOk={onApply}
      onCancel={onClose}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <Text strong>Status</Text>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Selectează status"
            value={statusFilter}
            onChange={setStatusFilter}
            options={[
              { value: 1, label: 'În așteptare' },
              { value: 2, label: 'În procesare' },
              { value: 3, label: 'Confirmat' },
            ]}
          />
        </div>
        <div>
          <Text strong>Client</Text>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Selectează client"
            value={clientFilter}
            onChange={setClientFilter}
            options={Array.from(new Set(products.map(p => p.oferta?.client_name))).map(name => ({
              value: name,
              label: name
            }))}
          />
        </div>
        <div>
          <Text strong>Perioadă</Text>
          <RangePicker
            style={{ width: '100%' }}
            value={dateRange}
            onChange={setDateRange}
          />
        </div>
      </Space>
    </Modal>
  );
};

export default FilterModal; 